import AxiosInstance from "./api";

export const EquipmentLedgerService = {
  getPaginate: async (payload) => {
    const query = new URLSearchParams(payload);
    return await AxiosInstance.get("/private/equipment-ledgers/paginate", {
      params: query,
    });
  },

  getById: async (id) => {
    return await AxiosInstance.get("/private/equipment-ledgers/" + id);
  },

  create: async (payload) => {
    return await AxiosInstance.post("/private/equipment-ledgers", payload);
  },

  update: async (id, payload) => {
    return await AxiosInstance.patch("/private/equipment-ledgers/" + id, payload);
  },

  delete: async (id) => {
    return await AxiosInstance.delete("/private/equipment-ledgers/" + id);
  },
};
